import { useState } from 'react'
import { Button } from '@zoom/react-ui'
import Disconnect from '../icons/Disconnect'
import { useAppSelector, useSelectAuth } from '../hooks/useRTK'
import { selectApp } from '../app/root'

const ConnectToContinue = () => {
  const [isConnected, setIsConnected] = useState(false)
  const app = useAppSelector(selectApp)!
  const auth = useSelectAuth(app)

  const handleConnect = () => {
    if (auth?.authUrl) {
      zoomSdk.openUrl({ url: auth.authUrl })
    }
    setIsConnected(true)
  }

  const handleRefresh = () => {
    window.location.reload()
  }

  const handleClick = () => {
    if (isConnected) {
      handleRefresh()
    } else {
      handleConnect()
    }
  }

  return (
    <div className='flex h-screen items-center justify-center px-4 md:px-10'>
      <div className='flex w-full max-w-[800px] flex-col items-center'>
        <Disconnect />

        <h1 className='mt-4 text-base font-[590]'>
          Connect to {app} to continue
        </h1>

        <p className='mt-2 text-center text-sm font-normal text-[#6E7680]'>
          Connect to {app} in your browser, then come back here to select a
          document.
        </p>

        <div className='mt-6 flex justify-center'>
          <Button
            onClick={handleClick}
            type='secondary'
          >
            {isConnected ? 'Refresh' : 'Connect'}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ConnectToContinue
